import { render, staticRenderFns } from "./DormRoomPanelCardFeature.vue?vue&type=template&id=13f91a0a&"
import script from "./DormRoomPanelCardFeature.vue?vue&type=script&lang=js&"
export * from "./DormRoomPanelCardFeature.vue?vue&type=script&lang=js&"
import style0 from "./DormRoomPanelCardFeature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports